import { SelectControlProps } from "./SelectControl.types";
import { useClassNames } from "../../../../structure";

export const SelectControl = <T, P>({
  getValidationClassName,
  onSelectChange,
  control,
  formState,
  value,
  error,
}: SelectControlProps<T, P>): React.ReactElement => {
  const classNames = useClassNames(["form-select", ...getValidationClassName()].concat(control.classNames || []));
  return (
    <select
      style={classNames}
      value={String(value)}
      onChange={onSelectChange}
      disabled={!!control.disabledIf && control.disabledIf(formState)}
    >
      {control.options?.map((option, index) => (
        <option key={index} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};
